
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { COUNTRIES } from '../data';

export const GalamerkiListing: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white relative overflow-hidden">
      {/* Cinematic Hero - Synchronized size */}
      <section className="relative h-[450px] md:h-[650px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2000&auto=format&fit=crop" 
            className="w-full h-full object-cover brightness-[0.4] scale-105"
            alt="Destinations Hero"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60"></div>
        </div>
        
        <div className="relative z-10 text-center px-6 md:px-12 lg:px-20 w-full max-w-[1400px]">
          <div className="inline-block bg-brand-accent text-white px-5 py-2 rounded-full text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em] mb-6 md:mb-8 animate-fade-in shadow-xl">
            Atklāj pasauli ar mums
          </div>
          {/* Title Size - Standardized */}
          <h1 className="text-4xl md:text-7xl font-black mb-4 text-white tracking-tighter leading-none animate-fade-in uppercase select-none">
            Mūsu <span className="text-brand-accent">Galamērķi</span>
          </h1>
          <div className="w-20 md:w-32 h-2 md:h-2.5 bg-brand-accent mx-auto mt-4 md:mt-6 rounded-full shadow-[0_4px_15px_rgba(255,130,46,0.6)]"></div>
        </div>
      </section>

      {/* Main Grid - Base 1 column, md 2, lg 3 */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 relative z-10 bg-white pt-12 md:pt-16 pb-16 md:pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {COUNTRIES.map((country) => (
            <div 
              key={country.id} 
              className="group bg-white rounded-lg overflow-hidden shadow-[0_30px_80px_-15px_rgba(5,7,60,0.1)] hover:shadow-[0_50px_100px_-15px_rgba(5,7,60,0.2)] transition-all duration-700 flex flex-col h-full border border-gray-100 transform hover:-translate-y-2 text-left"
            >
              <div 
                className="relative h-64 md:h-80 overflow-hidden cursor-pointer"
                onClick={() => navigate(`/galamerki/${country.slug}`)}
              >
                <img 
                  src={country.image} 
                  alt={country.name} 
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-deep via-transparent to-transparent opacity-80 transition-opacity"></div>
                <div className="absolute bottom-6 left-8 right-8">
                   <h2 className="text-2xl md:text-4xl font-black text-white tracking-tighter leading-none">{country.name}</h2>
                </div>
              </div>

              <div className="p-6 md:p-10 flex flex-col flex-grow">
                <div className="mb-6 md:mb-8 flex-grow">
                  <p className="text-[9px] font-black uppercase tracking-[0.2em] text-brand-accent mb-4">Populārākie kūrorti:</p>
                  <div className="flex flex-wrap gap-2">
                    {country.cities.map(city => (
                      <Link 
                        key={city.id} 
                        to={`/celojumi?destination=${encodeURIComponent(city.name)}`}
                        className="bg-brand-surface px-3 py-1.5 md:px-4 md:py-2.5 rounded-lg text-[10px] md:text-xs font-black text-brand-deep hover:bg-brand-accent hover:text-white transition-all border border-transparent hover:shadow-lg active:scale-95"
                      >
                        {city.name}
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="pt-5 border-t border-gray-50 flex items-center justify-between">
                  <div className="text-[8px] md:text-[9px] font-black uppercase tracking-widest text-brand-deep/30">
                    {country.cities.length} galamērķi
                  </div>
                  <button 
                    onClick={() => navigate(`/galamerki/${country.slug}`)}
                    className="flex items-center gap-2 text-brand-accent font-black uppercase text-[10px] md:text-[11px] tracking-widest group-hover:gap-4 transition-all"
                  >
                    Uzzināt vairāk <i className="fas fa-arrow-right text-[9px]"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Final Section - Full Width Background Optimized for Mobile */}
      <section className="bg-brand-surface py-16 md:py-32 relative overflow-hidden clip-circle-top z-20">
        <div className="absolute inset-0 bg-pattern-dots opacity-5 pointer-events-none"></div>
        <div className="absolute top-0 right-0 w-[250px] md:w-[600px] h-[250px] md:h-[600px] bg-brand-accent/5 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2"></div>
        
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 relative z-10 pt-10">
          <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-12">
            <div className="flex-1 space-y-6 md:space-y-8 text-center lg:text-left">
              <div className="inline-block bg-orange-50 text-brand-accent px-4 py-1.5 rounded-full text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em]">
                Konsultācija
              </div>
              <h2 className="text-3xl md:text-6xl font-black text-brand-deep tracking-tighter leading-tight">
                Nevarat izvēlēties <br/><span className="text-brand-accent italic">īsto</span> vietu?
              </h2>
              <p className="text-base md:text-xl text-brand-deep/70 font-bold leading-relaxed max-w-xl mx-auto lg:mx-0">
                Mūsu ceļojumu eksperti palīdzēs jums piemeklēt piemērotāko galamērķi, balstoties uz jūsu vēlmēm, budžetu un ceļojuma veidu.
              </p>
              <div className="pt-2 md:pt-4">
                <Link 
                  to="/kontakti" 
                  className="w-full md:w-auto inline-flex items-center justify-center gap-4 bg-brand-accent text-white px-10 py-4 md:px-12 md:py-5 rounded-lg font-black text-[11px] md:text-xs uppercase tracking-[0.2em] hover:bg-brand-deep transition-all shadow-2xl shadow-brand-accent/20 group"
                >
                  Sazinieties ar mums <i className="fas fa-headset text-lg group-hover:scale-110 transition-transform"></i>
                </Link>
              </div>
            </div>
            
            <div className="flex-1 w-full max-w-lg lg:max-w-none flex justify-center lg:justify-start">
              <div className="grid grid-cols-2 gap-4 md:gap-6 w-full max-w-[320px] md:max-w-[500px]">
                 {[
                   { icon: 'fas fa-umbrella-beach', label: 'Saulainākie krasti' },
                   { icon: 'fas fa-mountain', label: 'Aktīvie kalni' },
                   { icon: 'fas fa-leaf', label: 'Eksotiskā daba' },
                   { icon: 'fas fa-snowflake', label: 'Ziemas pasaka' }
                 ].map((item, i) => (
                    <div key={i} className="bg-white p-6 md:p-10 rounded-2xl text-center shadow-[0_15px_40px_rgba(0,0,0,0.05)] group hover:bg-brand-accent transition-all duration-500 border border-gray-100 flex flex-col items-center justify-center aspect-square">
                       <div className="text-2xl md:text-4xl text-brand-accent group-hover:text-white mb-3 md:mb-4 group-hover:scale-110 transition-transform duration-500"><i className={item.icon}></i></div>
                       <h4 className="font-black text-brand-deep group-hover:text-white uppercase text-[9px] md:text-[11px] tracking-[0.1em] leading-tight">{item.label}</h4>
                    </div>
                 ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
